// import { useState } from "react";
// import axios from "axios";
// import { RD_URL } from "../api/axiosInstance";

// export const useFingerprintCapture = () => {
//   const [pidData, setPidData] = useState("");
//   const [fpStatus, setFpStatus] = useState(""); // success | error | ""
//   const [fingerLoading, setFingerLoading] = useState(false);
//   const [step, setStep] = useState("");
//   const [error, setError] = useState("");

//   const captureFingerprint = async () => {
//     try {
//       setFingerLoading(true);
//       setFpStatus("");
//       setError("");
//       setStep("Discovering RD Service...");

//       await axios.get(`${RD_URL}/api/discover`);

//       setStep("Fetching Device Info...");
//       await axios.get(`${RD_URL}/api/device-info`);

//       setStep("Please place your finger on scanner...");

//       const pidXml = `<?xml version="1.0"?>
// <PidOptions ver="1.0">
//   <Opts fCount="1" fType="0" format="0" pidVer="2.0" timeout="10000" env="P"/>
// </PidOptions>`;

//       const res = await axios.post(
//         `${RD_URL}/api/capture`,
//         pidXml,
//         { headers: { "Content-Type": "text/xml" } }
//       );

//       if (res.data.includes('errCode="0"')) {
//         setPidData(res.data);
//         setFpStatus("success");
//         setStep("Authentication Successful ✅");
//       } else {
//         throw new Error("Fingerprint failed");
//       }
//     } catch (err) {
//       setPidData("");
//       setFpStatus("error");
//       setError("Fingerprint not captured ❌");
//     } finally {
//       setTimeout(() => {
//         setFingerLoading(false);
//         setStep("");
//       }, 2000);
//     }
//   };

//   const resetFingerprint = () => {
//     setPidData("");
//     setFpStatus("");
//     setError("");
//   };

//   return {
//     pidData,
//     fpStatus,
//     fingerLoading,
//     step,
//     error,
//     captureFingerprint,
//     resetFingerprint,
//   };
// };




import { useEffect, useState } from "react";
import axios from "axios";
import { RD_URL } from "../api/axiosInstance";

export const useFingerprintCapture = () => {
  const [pidData, setPidData] = useState("");
  const [fpStatus, setFpStatus] = useState(""); // success | error | ""
  const [fingerLoading, setFingerLoading] = useState(false);
  const [step, setStep] = useState("");
  const [error, setError] = useState("");

//   const captureFingerprint = async () => {
//   let FINAL_URL = null;

//   try {
//     setFingerLoading(true);
//     setFpStatus("");
//     setError("");
//     setStep("Discovering RD Service...");

//     // 🔍 1. Discover RD Service (Mantra)
//     for (let port = 11100; port <= 11120; port++) {
//       try {
//         const res = await axios({
//           method: "RDSERVICE",
//           url: `http://127.0.0.1:${port}`,
//           timeout: 800,
//         });

//         if (typeof res.data === "string" && res.data.includes("MANTRA")) {
//           FINAL_URL = `http://127.0.0.1:${port}`;
//           break;
//         }
//       } catch {
//         // silent retry
//       }
//     }

//     if (!FINAL_URL) {
//       throw new Error("RD Service not running");
//     }

//     // ℹ️ 2. DEVICE INFO (mandatory check)
//     setStep("Checking device...");
//     const deviceInfoRes = await axios({
//       method: "DEVICEINFO",
//       url: FINAL_URL,
//       timeout: 2000,
//     });

//     if (!deviceInfoRes?.data?.includes("<DeviceInfo")) {
//       throw new Error("Invalid device response");
//     }

//     // 🧬 3. CAPTURE Fingerprint
//     setStep("Capturing fingerprint...");

//     const pidOptionsXML = `<?xml version="1.0" encoding="UTF-8"?>
// <PidOptions ver="1.0">
//   <Opts
//     fCount="1"
//     fType="0"
//     iCount="0"
//     iType="0"
//     pCount="0"
//     pType="0"
//     format="0"
//     pidVer="2.0"
//     timeout="10000"
//     env="P"
//   />
// </PidOptions>`;

//     const captureRes = await axios({
//       method: "CAPTURE",
//       url: FINAL_URL,
//       data: pidOptionsXML,
//       headers: {
//         "Content-Type": "text/xml",
//       },
//       timeout: 15000,
//     });

//     const pidXML = captureRes?.data;

//     if (
//       typeof pidXML !== "string" ||
//       !pidXML.includes('errCode="0"')
//     ) {
//       throw new Error("Fingerprint capture failed");
//     }

//     // ✅ SUCCESS
//     setFpStatus("success");
//     setPidData(pidXML); // 🔐 Send this to backend only
//     setStep("Fingerprint captured successfully ✅");

//     return pidXML;

//   } catch (err) {
//     console.error("Fingerprint Error:", err?.message || err);
//     setFpStatus("error");
//     setError(
//       err?.message === "RD Service not running"
//         ? "RD Service not running ❌"
//         : "Fingerprint not captured ❌"
//     );
//     return null;

//   } finally {
//     setFingerLoading(false);
//     setStep("");
//   }
// };

// bank2: "18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw=",
// E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=

const BANK_WADH = {
  bank1: "E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=",
  bank2:"18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw=",
  bank3: "E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=",
  bank4: "TF/lfPuh1n4ZY1xizYpqikIBm+gv65r51MFNek4uwNw=",
  bank5: "E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=",
  bank6: "E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=",
};
const captureFingerprint = async (bankKey = "bank1") => {
  let FINAL_URL = "";

  try {
    setFingerLoading(true);
    setFpStatus("");
    setError("");
    setStep("Discovering RD Service...");

    // Discover RD Service
    for (let port = 11100; port <= 11120; port++) {
      try {
        const res = await axios({
          method: "RDSERVICE",
          url: `http://127.0.0.1:${port}`,
          timeout: 1000,
        });

        if (res?.data?.includes("Mantra")) {
          FINAL_URL = `http://127.0.0.1:${port}`;
          break;
        }
      } catch {}
    }

    if (!FINAL_URL) throw new Error("RD Service not found");

    // Device Info
    setStep("Fetching device info...");
    await axios({ method: "DEVICEINFO", url: FINAL_URL, timeout: 2000 });


//     {
//     "success": false,
//     "message": "Server error",
//     "error": "The IRIS field must be one of: 1,2,4.\n"
// }
    // Capture
    setStep("Capturing fingerprint...");

    const wadh = BANK_WADH[bankKey];

    const captureXML = `
      <PidOptions ver="1.0">
        <Opts fCount="1" fType="2" iCount="0" iType="0"
              pCount="0" pType="0"
              wadh="${wadh}"
              format="0" pidVer="2.0"
              timeout="10000" env="P"/>
      </PidOptions>
    `;

    

    const captureRes = await axios({
      method: "CAPTURE",
      url: FINAL_URL,
      data: captureXML,
      headers: { "Content-Type": "text/xml" },
      timeout: 15000,
    });

    if (!captureRes.data.includes('errCode="0"')) {
      throw new Error("Fingerprint capture failed");
    }

    setFpStatus("success");
    setStep("Fingerprint captured ✅");
    setPidData(captureRes.data);
    return captureRes.data;

  } catch (err) {
    console.error(err);
    setFpStatus("error");
    setError(err.message || "Fingerprint failed ❌");
  } finally {
    setFingerLoading(false);
    setStep("");
  }
};


//   const captureFingerprint = async () => {
//   let FINAL_URL = "";

//   try {
//     setFingerLoading(true);
//     setFpStatus("");
//     setError("");
//     setStep("Discovering RD Service...");

//     // 1️⃣ Discover RD Service
//     for (let port = 11100; port <= 11120; port++) {
//       try {
//         const response = await axios({
//           method: "RDSERVICE",
//           url: `http://127.0.0.1:${port}`,
//           timeout: 1000,
//         });

//         if (response?.data?.includes("Mantra")) {
//           FINAL_URL = `http://127.0.0.1:${port}`;
//           break;
//         }
//       } catch (err) {
//         // ignore and try next port
//       }
//     }

//     if (!FINAL_URL) {
//       throw new Error("RD Service not found");
//     }

//     // 2️⃣ Get Device Info
//     setStep("Fetching device info...");
//     const deviceInfoRes = await axios({
//       method: "DEVICEINFO",
//       url: FINAL_URL,
//       timeout: 2000,
//     });


//        if (!deviceInfoRes?.data || !deviceInfoRes) {
//       throw new Error("Invalid device response");
//     }

//     //  setStep("Place finger on scanner");
//     // 3️⃣ Capture Fingerprint
//     setStep("Capturing fingerprint...");

//     const captureXML = `<PidOptions ver="1.0">
//         <Opts fCount="1" fType="2" iCount="0" iType="0"
//               pCount="0" pType="0"
//                wadh="18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw="
//               format="0" pidVer="2.0"
//               timeout="10000" env="P"/>
//       </PidOptions>`;

//     const captureRes = await axios({
//       method: "CAPTURE",
//       url: FINAL_URL,
//       data: captureXML,
//       headers: {
//         "Content-Type": "text/xml",
//       },
//       timeout: 15000,
//     });

//     if (captureRes.data.includes("errCode=\"0\"")) {
//       setFpStatus("success");
//       setStep("Fingerprint captured successfully ✅");

  
//         setPidData(captureRes.data);

//         return captureRes.data; // 🔥 IMPORTANT


//     } else {
//       throw new Error("Fingerprint capture failed");
//     }

//   } catch (err) {
//     console.error("Fingerprint Error:", err);
//     setFpStatus("error");
//   setError(err?.message || "Fingerprint not captured ❌");

//   } finally {
//     setFingerLoading(false);
//     setStep("");
//   }
// };


// done 

//   const captureFingerprintEkyBank2 = async () => {
//   let FINAL_URL = "";

//   try {
//     setFingerLoading(true);
//     setFpStatus("");
//     setError("");
//     setStep("Discovering RD Service...");

//     // 1️⃣ Discover RD Service
//     for (let port = 11100; port <= 11120; port++) {
//       try {
//         const response = await axios({
//           method: "RDSERVICE",
//           url: `http://127.0.0.1:${port}`,
//           timeout: 1000,
//         });

//         if (response?.data?.includes("Mantra")) {
//           FINAL_URL = `http://127.0.0.1:${port}`;
//           break;
//         }
//       } catch (err) {
//         // ignore and try next port
//       }
//     }

//     if (!FINAL_URL) {
//       throw new Error("RD Service not found");
//     }

//     // 2️⃣ Get Device Info
//     setStep("Fetching device info...");
//     const deviceInfoRes = await axios({
//       method: "DEVICEINFO",
//       url: FINAL_URL,
//       timeout: 2000,
//     });


//        if (!deviceInfoRes?.data || !deviceInfoRes) {
//       throw new Error("Invalid device response");
//     }

//     //  setStep("Place finger on scanner");
//     // 3️⃣ Capture Fingerprint
//     setStep("Capturing fingerprint...");

//     const captureXML = `<PidOptions ver="1.0">
//         <Opts fCount="1" fType="2" iCount="0" iType="0"
//               pCount="0" pType="0"
//                wadh="18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw="
//               format="0" pidVer="2.0"
//               timeout="10000" env="P"/>
//       </PidOptions>`;

//     const captureRes = await axios({
//       method: "CAPTURE",
//       url: FINAL_URL,
//       data: captureXML,
//       headers: {
//         "Content-Type": "text/xml",
//       },
//       timeout: 15000,
//     });

//     if (captureRes.data.includes("errCode=\"0\"")) {
//       setFpStatus("success");
//       setStep("Fingerprint captured successfully ✅");

  
//         setPidData(captureRes.data);

//         return captureRes.data; // 🔥 IMPORTANT


//     } else {
//       throw new Error("Fingerprint capture failed");
//     }

//   } catch (err) {
//     console.error("Fingerprint Error:", err);
//     setFpStatus("error");
//   setError(err?.message || "Fingerprint not captured ❌");

//   } finally {
//     setFingerLoading(false);
//     setStep("");
//   }
// };
//   const captureFingerprintBank5 = async () => {
//   let FINAL_URL = "";

//   try {
//     setFingerLoading(true);
//     setFpStatus("");
//     setError("");
//     setStep("Discovering RD Service...");

//     // 1️⃣ Discover RD Service
//     for (let port = 11100; port <= 11120; port++) {
//       try {
//         const response = await axios({
//           method: "RDSERVICE",
//           url: `http://127.0.0.1:${port}`,
//           timeout: 1000,
//         });

//         if (response?.data?.includes("Mantra")) {
//           FINAL_URL = `http://127.0.0.1:${port}`;
//           break;
//         }
//       } catch (err) {
//         // ignore and try next port
//       }
//     }

//     if (!FINAL_URL) {
//       throw new Error("RD Service not found");
//     }

//     // 2️⃣ Get Device Info
//     setStep("Fetching device info...");
//     const deviceInfoRes = await axios({
//       method: "DEVICEINFO",
//       url: FINAL_URL,
//       timeout: 2000,
//     });


//        if (!deviceInfoRes?.data || !deviceInfoRes) {
//       throw new Error("Invalid device response");
//     }

//     //  setStep("Place finger on scanner");
//     // 3️⃣ Capture Fingerprint
//     setStep("Capturing fingerprint...");

//     const captureXML = `<PidOptions ver="1.0">
//         <Opts fCount="1" fType="2" iCount="0" iType="0"
//               pCount="0" pType="0"
//                wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc="
//               format="0" pidVer="2.0"
//               timeout="10000" env="P"/>
//       </PidOptions>`;

//     const captureRes = await axios({
//       method: "CAPTURE",
//       url: FINAL_URL,
//       data: captureXML,
//       headers: {
//         "Content-Type": "text/xml",
//       },
//       timeout: 15000,
//     });

//     if (captureRes.data.includes("errCode=\"0\"")) {
//       setFpStatus("success");
//       setStep("Fingerprint captured successfully ✅");

  
//         setPidData(captureRes.data);

//         return captureRes.data; // 🔥 IMPORTANT


//     } else {
//       throw new Error("Fingerprint capture failed");
//     }

//   } catch (err) {
//     console.error("Fingerprint Error:", err);
//     setFpStatus("error");
//   setError(err?.message || "Fingerprint not captured ❌");

//   } finally {
//     setFingerLoading(false);
//     setStep("");
//   }
// };
//   const captureFingerprintBank6 = async () => {
//   let FINAL_URL = "";

//   try {
//     setFingerLoading(true);
//     setFpStatus("");
//     setError("");
//     setStep("Discovering RD Service...");

//     // 1️⃣ Discover RD Service
//     for (let port = 11100; port <= 11120; port++) {
//       try {
//         const response = await axios({
//           method: "RDSERVICE",
//           url: `http://127.0.0.1:${port}`,
//           timeout: 1000,
//         });

//         if (response?.data?.includes("Mantra")) {
//           FINAL_URL = `http://127.0.0.1:${port}`;
//           break;
//         }
//       } catch (err) {
//         // ignore and try next port
//       }
//     }

//     if (!FINAL_URL) {
//       throw new Error("RD Service not found");
//     }

//     // 2️⃣ Get Device Info
//     setStep("Fetching device info...");
//     const deviceInfoRes = await axios({
//       method: "DEVICEINFO",
//       url: FINAL_URL,
//       timeout: 2000,
//     });


//        if (!deviceInfoRes?.data || !deviceInfoRes) {
//       throw new Error("Invalid device response");
//     }

//     //  setStep("Place finger on scanner");
//     // 3️⃣ Capture Fingerprint
//     setStep("Capturing fingerprint...");

//     const captureXML = `<PidOptions ver="1.0">
//         <Opts fCount="1" fType="2" iCount="0" iType="0"
//               pCount="0" pType="0"
//                wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc="
//               format="0" pidVer="2.0"
//               timeout="10000" env="P"/>
//       </PidOptions>`;

//     const captureRes = await axios({
//       method: "CAPTURE",
//       url: FINAL_URL,
//       data: captureXML,
//       headers: {
//         "Content-Type": "text/xml",
//       },
//       timeout: 15000,
//     });

//     if (captureRes.data.includes("errCode=\"0\"")) {
//       setFpStatus("success");
//       setStep("Fingerprint captured successfully ✅");

  
//         setPidData(captureRes.data);

//         return captureRes.data; // 🔥 IMPORTANT


//     } else {
//       throw new Error("Fingerprint capture failed");
//     }

//   } catch (err) {
//     console.error("Fingerprint Error:", err);
//     setFpStatus("error");
//   setError(err?.message || "Fingerprint not captured ❌");

//   } finally {
//     setFingerLoading(false);
//     setStep("");
//   }
// };

//   const captureFingerprintBank3 = async () => {
//   let FINAL_URL = "";

//   try {
//     setFingerLoading(true);
//     setFpStatus("");
//     setError("");
//     setStep("Discovering RD Service...");

//     // 1️⃣ Discover RD Service
//     for (let port = 11100; port <= 11120; port++) {
//       try {
//         const response = await axios({
//           method: "RDSERVICE",
//           url: `http://127.0.0.1:${port}`,
//           timeout: 1000,
//         });

//         if (response?.data?.includes("Mantra")) {
//           FINAL_URL = `http://127.0.0.1:${port}`;
//           break;
//         }
//       } catch (err) {
//         // ignore and try next port
//       }
//     }

//     if (!FINAL_URL) {
//       throw new Error("RD Service not found");
//     }

//     // 2️⃣ Get Device Info
//     setStep("Fetching device info...");
//     const deviceInfoRes = await axios({
//       method: "DEVICEINFO",
//       url: FINAL_URL,
//       timeout: 2000,
//     });


//        if (!deviceInfoRes?.data || !deviceInfoRes) {
//       throw new Error("Invalid device response");
//     }

//     //  setStep("Place finger on scanner");
//     // 3️⃣ Capture Fingerprint
//     setStep("Capturing fingerprint...");

//     const captureXML = `<PidOptions ver="1.0">
//         <Opts fCount="1" fType="2" iCount="0" iType="0"
//               pCount="0" pType="0"
//                wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc="
//               format="0" pidVer="2.0"
//               timeout="10000" env="P"/>
//       </PidOptions>`;

//     const captureRes = await axios({
//       method: "CAPTURE",
//       url: FINAL_URL,
//       data: captureXML,
//       headers: {
//         "Content-Type": "text/xml",
//       },
//       timeout: 15000,
//     });

//     if (captureRes.data.includes("errCode=\"0\"")) {
//       setFpStatus("success");
//       setStep("Fingerprint captured successfully ✅");

  
//         setPidData(captureRes.data);

//         return captureRes.data; // 🔥 IMPORTANT


//     } else {
//       throw new Error("Fingerprint capture failed");
//     }

//   } catch (err) {
//     console.error("Fingerprint Error:", err);
//     setFpStatus("error");
//   setError(err?.message || "Fingerprint not captured ❌");

//   } finally {
//     setFingerLoading(false);
//     setStep("");
//   }
// };

//   const captureFingerprintBank1 = async () => {
//   let FINAL_URL = "";

//   try {
//     setFingerLoading(true);
//     setFpStatus("");
//     setError("");
//     setStep("Discovering RD Service...");

//     // 1️⃣ Discover RD Service
//     for (let port = 11100; port <= 11120; port++) {
//       try {
//         const response = await axios({
//           method: "RDSERVICE",
//           url: `http://127.0.0.1:${port}`,
//           timeout: 1000,
//         });

//         if (response?.data?.includes("Mantra")) {
//           FINAL_URL = `http://127.0.0.1:${port}`;
//           break;
//         }
//       } catch (err) {
//         // ignore and try next port
//       }
//     }

//     if (!FINAL_URL) {
//       throw new Error("RD Service not found");
//     }

//     // 2️⃣ Get Device Info
//     setStep("Fetching device info...");
//     const deviceInfoRes = await axios({
//       method: "DEVICEINFO",
//       url: FINAL_URL,
//       timeout: 2000,
//     });


//        if (!deviceInfoRes?.data || !deviceInfoRes) {
//       throw new Error("Invalid device response");
//     }

//     //  setStep("Place finger on scanner");
//     // 3️⃣ Capture Fingerprint
//     setStep("Capturing fingerprint...");

//     const captureXML = `<PidOptions ver="1.0">
//         <Opts fCount="1" fType="2" iCount="0" iType="0"
//               pCount="0" pType="0"
//                wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc="
//               format="0" pidVer="2.0"
//               timeout="10000" env="P"/>
//       </PidOptions>`;

//     const captureRes = await axios({
//       method: "CAPTURE",
//       url: FINAL_URL,
//       data: captureXML,
//       headers: {
//         "Content-Type": "text/xml",
//       },
//       timeout: 15000,
//     });

//     if (captureRes.data.includes("errCode=\"0\"")) {
//       setFpStatus("success");
//       setStep("Fingerprint captured successfully ✅");

  
//         setPidData(captureRes.data);

//         return captureRes.data; // 🔥 IMPORTANT


//     } else {
//       throw new Error("Fingerprint capture failed");
//     }

//   } catch (err) {
//     console.error("Fingerprint Error:", err);
//     setFpStatus("error");
//   setError(err?.message || "Fingerprint not captured ❌");

//   } finally {
//     setFingerLoading(false);
//     setStep("");
//   }
// };

//   const captureFingerprint = async () => {
//     try {
//       setFingerLoading(true);
//       setFpStatus("");
//       setError("");

//       setStep("Discovering RD Service...");
//       await axios.get(`${RD_URL}/api/discover`);

//       setStep("Fetching Device Info...");
//       await axios.get(`${RD_URL}/api/device-info`);

//       setStep("Place finger on scanner");

//       const pidXml = `<?xml version="1.0"?>
// <PidOptions ver="1.0">
//   <Opts fCount="1" fType="0" format="0" pidVer="2.0" timeout="10000" env="P"/>
// </PidOptions>`;

//       const res = await axios.post(
//         `${RD_URL}/api/capture`,
//         pidXml,
//         { headers: { "Content-Type": "text/xml" } }
//       );

//       if (res.data?.includes('errCode="0"')) {
//         setPidData(res.data);
//         setFpStatus("success");
//         return res.data; // 🔥 IMPORTANT
//       }

//       throw new Error("Fingerprint failed");
//     } catch (err) {
//       setFpStatus("error");
//       setError("Fingerprint not captured ❌");
//       throw err;
//     } finally {
//       setFingerLoading(false); // ❌ no delay
//       setStep("");
//     }
//   };

  const resetFingerprint = () => {
    setPidData("");
    setFpStatus("");
    setError("");
  };

   useEffect(() => {
  if (fpStatus === "error") {
    const timer = setTimeout(() => {
      setFpStatus("");
    }, 5000);

    return () => clearTimeout(timer);
  }
}, [fpStatus]);

  return {
    pidData,
    fpStatus,
    fingerLoading,
    step,
    error,
    captureFingerprint,
    resetFingerprint,
  };
};
